/**
 * Sets a cookie with the given name, value, and expiration days
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Number of days until expiration
 */
export function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
}

/**
 * Gets a cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} - Cookie value or null if not found
 */
export function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
}

/**
 * Deletes a cookie by name
 * @param {string} name - Cookie name
 */
export function deleteCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
}

/**
 * Sets the referral tracking cookie (prefserv)
 * @param {string} referralCode - The referral code to store
 * @param {number} days - Number of days until expiration
 */
export function setReferralCookie(referralCode, days) {
  try {
    setCookie('prefserv', referralCode, days);

    // Verify the cookie was set
    const verifyCookie = getReferralCookie();

    if (verifyCookie !== referralCode) {
      // Cookie verification failed, but we don't throw an error
      // as this might be due to browser security policies
    }
  } catch (error) {
    // Handle error silently
  }
}

/**
 * Gets the referral tracking cookie (prefserv)
 * @returns {string|null} - Referral code or null if not found
 */
export function getReferralCookie() {
  return getCookie('prefserv');
}

/**
 * Deletes the referral tracking cookie (prefserv)
 */
export function deleteReferralCookie() {
  deleteCookie('prefserv');
} 

/**
 * Sets account creation referral cookie (pl_ac_ref)
 */
export function setAccountCreationCookie(referralCode, days) {
  setCookie('pl_ac_ref', referralCode, days);
}

/**
 * Gets account creation referral cookie (pl_ac_ref)
 */
export function getAccountCreationCookie(request = null) {
  // Server-side (React Router action)
  if (request) {
    const cookieHeader = request.headers.get("Cookie");
    if (!cookieHeader) return null;

    const match = cookieHeader.match(/(?:^|;\s*)pl_ac_ref=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  // Client-side (browser)
  return getCookie('pl_ac_ref');
}

/**
 * Deletes account creation referral cookie (pl_ac_ref)
 */
export function deleteAccountCreationCookie() {
  deleteCookie('pl_ac_ref');
}
